export enum ShipmentStepEnum {
	StepZero = 0,
	StepOne = 1,
	StepTwo = 2,
	StepThree = 3,
	StepFour = 4,
	StepFive = 5,
	StepNegativeOne = -1
}

export namespace ShipmentStepEnum {
	export function toDescription(val: ShipmentStepEnum) {
		switch (val) {
			case 0:
				return "Product Prep";
			case 1:
				return "Shipping Prep";
			case 2:
				return "QC Check";
			case 3:
				return "Pending Shipment";
			case 4:
				return "Completed";
			case 5:
				return "Delivered";
			case -1:
				return "Not Submitted";
		}
		return null;
	}
	export function toDisplay(val: ShipmentStepEnum) {
		switch (val) {
			case 0:
				return "Product Prep";
			case 1:
				return "Shipping Prep";
			case 2:
				return "QC Check";
			case 3:
				return "Pending Shipment";
			case 4:
				return "Completed";
			case 5:
				return "Delivered";
			case -1:
				return "Not Submitted";
		}
		return null;
	}
}
